var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M10.9395 10.9393C10.3537 11.5251 10.3537 12.4749 10.9395 13.0607L20.4854 22.6066C21.0712 23.1924 22.0209 23.1924 22.6067 22.6066C23.1925 22.0208 23.1925 21.0711 22.6067 20.4853L14.1214 12L22.6067 3.51472C23.1925 2.92893 23.1925 1.97918 22.6067 1.3934C22.0209 0.807609 21.0712 0.807609 20.4854 1.3934L10.9395 10.9393ZM13.0001 10.5L12.0001 10.5L12.0001 13.5L13.0001 13.5L13.0001 10.5Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 2",
    d: "M0.939462 10.9393C0.353675 11.5251 0.353675 12.4749 0.939462 13.0607L10.4854 22.6066C11.0712 23.1924 12.0209 23.1924 12.6067 22.6066C13.1925 22.0208 13.1925 21.0711 12.6067 20.4853L4.12144 12L12.6067 3.51472C13.1925 2.92893 13.1925 1.97918 12.6067 1.3934C12.0209 0.807609 11.0712 0.807609 10.4854 1.3934L0.939462 10.9393ZM3.00012 10.5L2.00012 10.5L2.00012 13.5L3.00012 13.5L3.00012 10.5Z",
    fill: "#F26F21",
    fillOpacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoArrows);
export default __webpack_public_path__ + "static/media/two-arrows.f9c7376b34a02e513e33fad94f951e75.svg";
export { ForwardRef as ReactComponent };